import { Company, CompanyInputDTO, Invited, InvitedInputDTO } from '~/models/Company';
import { CompanyDocument, PersonalDocument } from '@scansource-brazil/zeus-core-ui/utils';
import { COMPANY_TYPE_ENUM } from '~/enums/CompanyType';

export class AdaptCompany {
  private static convertDate(dateString: string | null): Date | null {
    if (!dateString || dateString === '0001-01-01T00:00:00') {
      return null;
    }
    return new Date(dateString);
  }

  public static toModel(inputDTO: CompanyInputDTO): Company {
    try {
      if (!inputDTO) {
        throw new Error('CompanyInputDTO não pode ser nulo ou indefinido');
      }

      const dto = new CompanyInputDTO(inputDTO);

      if (!dto.companyType) {
        throw new Error('O tipo de empresa (companyType) é obrigatório');
      }

      return new Company({
        economicGroupRoot: dto.economicGroupRoot,
        companyDocument: new CompanyDocument(dto.companyDocument),
        companyName: dto.companyName,
        companyType: COMPANY_TYPE_ENUM[dto.companyType] as keyof typeof COMPANY_TYPE_ENUM,
        phoneNumber: dto.phoneNumber,
        invitedList: dto.invitedList ? this.toModelInvitedList(dto.invitedList) : [],
        id: dto.id,
        created: this.convertDate(dto.created),
        updated: this.convertDate(dto.updated),
        valid: dto.valid,
        tenant: dto.tenant,
      });
    } catch (error) {
      console.error('Erro ao adaptar Company:', error instanceof Error ? error.message : 'Erro desconhecido');
      throw new Error('Falha ao converter dados da empresa');
    }
  }

  private static toModelInvitedList(inputDTO: InvitedInputDTO[]): Invited[] {
    return inputDTO.map(
      (dto) =>
        new Invited({
          email: dto.email,
          firstName: dto.firstName,
          lastName: dto.lastName,
          document: new PersonalDocument(dto.document),
          phoneNumber: dto.phoneNumber,
          invitationCode: dto.invitationCode,
          invitationStatus: dto.invitationStatus,
          orderNumber: dto.orderNumber,
          invitationDate: this.convertDate(dto.invitationDate),
        }),
    );
  }

  public static toModelList(inputDTOList: CompanyInputDTO[]): Company[] {
    return inputDTOList.map((inputDTO) => this.toModel(inputDTO));
  }
}
